exports = module.exports = require("../../../../../../develop/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-input[data-v-eacd8cfc] input{width:110px}.select-box[data-v-eacd8cfc]{max-width:110px}.info-table[data-v-eacd8cfc]{font-size:16px}.info-label[data-v-eacd8cfc]{vertical-align:text-top;font-size:10px}.info-sum[data-v-eacd8cfc]{font-size:18px;text-align:right}.info-sell[data-v-eacd8cfc]{color:red}.info-buy[data-v-eacd8cfc]{color:green}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/css-loader?minimize!/Users/gtirby/develop/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eacd8cfc","scoped":true,"hasInlineConfig":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/OrderList.vue
// module id = 373
// module chunks = 0